module.exports = __webpack_public_path__ + "static/media/Logo.90fea378.png";